import { ApiPaths } from 'api/constants';
import {
  UpdateUserDetails,
  User,
  UserWithIdentityProviderAndLastAccessed,
} from 'api/endpoints/users';
import ApiUrlParams from 'constants/apiUrlParams';
import BaseRepo from 'container/BaseRepo';
import { ApiResponseAsync } from 'container/models';

import { IManagementUsersRepo } from './IManagementUsers';

export class ManagementUsersRepo
  extends BaseRepo
  implements IManagementUsersRepo
{
  getUsers = (): ApiResponseAsync<
    DataWithTotal<UserWithIdentityProviderAndLastAccessed>
  > => this.helpers.handleGet(ApiPaths.users._());

  activateUser = (user: User): ApiResponseAsync<void> =>
    this.helpers.handlePostAction(
      ApiPaths.users.byId.activate._({ [ApiUrlParams.userId]: user.id }),
      {}
    );

  deactivateUser = (user: User): ApiResponseAsync<void> =>
    this.helpers.handlePostAction(
      ApiPaths.users.byId.deactivate._({ [ApiUrlParams.userId]: user.id }),
      {}
    );

  getUserDetails = (user: User): ApiResponseAsync<User> =>
    this.helpers.handleGet(
      ApiPaths.users.byId._({ [ApiUrlParams.userId]: user.id })
    );

  updateUserDetails = (
    user: User,
    updates: UpdateUserDetails
  ): ApiResponseAsync<User> =>
    this.helpers.handlePut(
      ApiPaths.users.byId._({ [ApiUrlParams.userId]: user.id }),
      updates.data
    );
}
